export enum UtmLeadProductType {
  SEM_CHALLAN = 'SEM_CHALLAN',
  SEM_CHALLAN_1 = 'SEM_CHALLAN_1',
  SEM_CHALLAN_2 = 'SEM_CHALLAN_2',
  SEM_CHALLAN_3 = 'SEM_CHALLAN_3',
  SEM_CHALLAN_4 = 'SEM_CHALLAN_4',
  SEM_CHALLAN_5 = 'SEM_CHALLAN_5',
  SEM_CHALLAN_6 = 'SEM_CHALLAN_6',
  SEM_CHALLAN_7 = 'SEM_CHALLAN_7',
  SEM_CHALLAN_8 = 'SEM_CHALLAN_8',
  SEM_CHALLAN_9 = 'SEM_CHALLAN_9',
  SEM_CHALLAN_10 = 'SEM_CHALLAN_10',
  PMAX_CHALLAN = 'PMAX_CHALLAN',
  META_CHALLAN = 'META_CHALLAN',
  SEO_CHALLAN = 'SEO_CHALLAN_PAGE',
  INSTAGRAM_CHALLAN = 'INSTAGRAM_CHALLAN',
  ZEPTO_CHALLAN = 'ZEPTO_CHALLAN',
  ZOMATO_CHALLAN = 'ZOMATO_CHALLAN',
  SEO_FASTAG = 'SEO_FASTag',
  SEM_FASTAG = 'SEM_FASTAG',
  PMAX_FASTAG = 'PMAX_FASTAG',
  BRANDFORMANCE_FASTAG = 'BRANDFORMANCE_FASTAG',
  META_FASTAG = 'META_FASTAG',
  WHATSAPP_WINBACK_CHALLAN = 'WHATSAPP_WINBACK_CHALLAN',
  BRANDFORMANCE_CHALLAN = 'BRANDFORMANCE_CHALLAN',
  SEM_HSRP = 'SEM_HSRP',
  SEO_HSRP = 'SEO_HSRP',
  CX_WA_WNBCK_CHLN_U1 = 'CX_WA_WNBCK_CHLN_U1',
  CX_WA_WNBCK_CHLN_U2 = 'CX_WA_WNBCK_CHLN_U2',
  CX_WA_WNBCK_CHLN_U3 = 'CX_WA_WNBCK_CHLN_U3',
  CX_WA_WNBCK_CHLN_U4 = 'CX_WA_WNBCK_CHLN_U4',
  CX_WA_WNBCK_CHLN_P1 = 'CX_WA_WNBCK_CHLN_P1',
  NCX_WA_WNBCK_CHLN_U1 = 'NCX_WA_WNBCK_CHLN_U1',
  NCX_WA_WNBCK_CHLN_U2 = 'NCX_WA_WNBCK_CHLN_U2',
  NCX_WA_WNBCK_CHLN_P1 = 'NCX_WA_WNBCK_CHLN_P1',
  NCX_WA_WNBCK_CHLN_U3 = 'NCX_WA_WNBCK_CHLN_U3',
  NCX_WA_WNBCK_CHLN_U4 = 'NCX_WA_WNBCK_CHLN_U4',
  META_CHALLAN_INF1 = 'META_CHALLAN_INF1',
  META_CHALLAN_INF2 = 'META_CHALLAN_INF2',
  META_CHALLAN_INF3 = 'META_CHALLAN_INF3',
  META_CHALLAN_INF4 = 'META_CHALLAN_INF4',
  META_CHALLAN_INF5 = 'META_CHALLAN_INF5',
  YT_CHALLAN_INF1 = 'YT_CHALLAN_INF1',
  YT_CHALLAN_INF2 = 'YT_CHALLAN_INF2',
  YT_CHALLAN_INF3 = 'YT_CHALLAN_INF3',
  YT_CHALLAN_INF4 = 'YT_CHALLAN_INF4',
  YT_CHALLAN_INF5 = 'YT_CHALLAN_INF5',
  KA_DISC_CHLN_GOV = 'KA_DISC_CHLN_GOV',
}
